import i18n from 'src/i18n'
import { ButtonActionsProps } from './buttonActions.types'
import { CancelButton, SubmitButton, Wrapper } from './buttonActions.styles'

const ButtonActions = ({
  disabledActions,
  disabledSubmit,
  onReset,
  onSubmit
}: ButtonActionsProps) => {
  return (
    <Wrapper className="_d-flex">
      <CancelButton
        className="_border _border-gray-300 _text-1 _text-gray-500 _rounded"
        disabled={disabledActions}
        onClick={onReset}
      >
        {i18n.t('comments.button_cancel')}
      </CancelButton>

      <SubmitButton
        className="_text-1 _rounded _bg-blue _text-white"
        disabled={disabledSubmit || disabledActions}
        onClick={onSubmit}
      >
        {i18n.t('comments.button_publish')}
      </SubmitButton>
    </Wrapper>
  )
}

export default ButtonActions
